import { useReactTable } from '@tanstack/react-table';

import { isActionColumn } from '../hooks/useIsActionColumn';
import { setColumnSizes } from '../layoutHelpers/setColumnSizes';
import { Th } from './Th/Th';

type TableHeaderProps<TData> = {
  table: ReturnType<typeof useReactTable<TData>>;
  showCellBorders: boolean;
  columnsWidth: string;
};

export const TableHeader = <TData = unknown,>({ table, showCellBorders, columnsWidth }: TableHeaderProps<TData>) => {
  return (
    <thead className="sticky top-0 left-0 z-10">
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header, index) => {
            const isAction = isActionColumn(header.column.columnDef);
            const fixedWidth = header.column.columnDef.meta?.style?.width;

            return (
              <Th<TData>
                isAction={isAction}
                key={header.id}
                header={header}
                betweenCellBorders={showCellBorders}
                isFirstColumn={!index}
                isLastColumn={index === headerGroup.headers.length - 1}
                ref={(thElem: HTMLTableCellElement | null) => setColumnSizes(thElem, table, header.column)}
                style={
                  !isAction
                    ? { width: fixedWidth ?? columnsWidth, minWidth: fixedWidth, maxWidth: fixedWidth }
                    : undefined
                }
              />
            );
          })}
        </tr>
      ))}
    </thead>
  );
};
